import React from 'react';
import { Info } from 'lucide-react';
interface PaymentNoticeProps {
  /** "compact" is a single short line for tight spaces like the mobile unlock bar. */
  variant?: 'default' | 'compact';
  className?: string;
}

/**
 * Temporary card-network notice shown only where customers start checkout.
 * Display-only — it does not affect checkout behavior.
 */
export function PaymentNotice({
  variant = 'default',
  className = ''
}: PaymentNoticeProps) {
  if (variant === 'compact') {
    return <p className={`flex items-center justify-center gap-1.5 text-center text-[11px] leading-snug text-amber-200 ${className}`} data-id="element-1640" data-mp="3g51160b8gkxx">
        <Info size={12} className="shrink-0 text-amber-300" aria-hidden="true" data-id="element-1641" data-mp="32cbf5vvpfg0t" />
        Visa is temporarily unavailable — paying by card? Please use Mastercard.
      </p>;
  }
  return <div role="note" aria-labelledby="payment-notice-title" className={`flex items-start gap-3 rounded-lg border border-amber-400/30 bg-amber-400/[0.07] px-4 py-3 text-left ${className}`} data-id="element-1642" data-mp="3u37popual8kx">
      <Info size={16} className="mt-0.5 shrink-0 text-amber-300" aria-hidden="true" data-id="element-1643" data-mp="w4lgec8vj9ax" />
      <div className="min-w-0" data-id="element-1644" data-mp="r5s3akxi1kba">
        <p id="payment-notice-title" className="text-sm font-semibold text-amber-200" data-id="element-1645" data-mp="r2ns33lm9ob4">
          Important Payment Notice
        </p>
        <p className="mt-1 text-[13px] leading-relaxed text-amber-50/85" data-id="element-1646" data-mp="1136ikh7os320">
          Visa payments are temporarily unavailable for the moment. If you&apos;re paying by
          card, please use Mastercard instead. We apologize for the inconvenience.
        </p>
      </div>
    </div>;
}